import { TrackingService } from './tracking.service';
import angulartics from 'angulartics';

export default angular
  .module('ng1-tracking', [angulartics])
  .service('trackingService', TrackingService)
  .name;
